import { Paperclip, FileText, X, Loader2 } from "lucide-react";
import { api } from "../../lib/api";

export function PortalMessages({ messages, attachments, setAttachments, newMsg, setNewMsg, uploadingCount, uploadProgress, addAttachments, send }) {
  return (
    <div className="de-card p-6">
      <div className="label-eyebrow mb-4">Messages</div>
      <div className="space-y-3 max-h-80 overflow-y-auto mb-4">
        {messages.length===0 && <div className="text-sm text-[#6B7280]">No messages yet.</div>}
        {messages.map(m=>(
          <div key={m.id} className={`p-3 border ${m.from_==="team"?"bg-[#F4F4F4] border-[#E5E7EB]":"bg-white border-[#C79A3B]"}`}>
            <div className="label-eyebrow mb-1">{m.from_==="team"?"The Extension Works":"You"} · {new Date(m.created_at).toLocaleString("en-GB")}</div>
            {m.body && <div className="text-sm whitespace-pre-wrap">{m.body}</div>}
            {m.attachments?.length>0 && (
              <div className="mt-2 flex flex-wrap gap-2" data-testid={`msg-attachments-${m.id}`}>
                {m.attachments.map(a=>{
                  const url = `${api.defaults.baseURL}/portal/file/${a.id}`;
                  const isImg = (a.content_type||"").startsWith("image/");
                  return isImg ? (
                    <a key={a.id} href={url} target="_blank" rel="noreferrer" data-testid={`msg-att-${a.id}`}>
                      <img src={url} alt={a.filename||""} className="w-20 h-20 object-cover border border-[#E5E7EB]"/>
                    </a>
                  ) : (
                    <a key={a.id} href={url} target="_blank" rel="noreferrer" data-testid={`msg-att-${a.id}`}
                       className="inline-flex items-center gap-2 border border-[#E5E7EB] px-2 py-1.5 text-xs bg-white hover:border-[#12263A]">
                      <FileText size={14}/> {a.filename||"file"}
                    </a>
                  );
                })}
              </div>
            )}
          </div>
        ))}
      </div>
      {attachments.length>0 && (
        <div className="flex flex-wrap gap-2 mb-2" data-testid="msg-staged">
          {attachments.map(a=>(
            <div key={a.id} className="relative">
              {a.isImage
                ? <img src={a.preview} className="w-14 h-14 object-cover border border-[#E5E7EB]" alt=""/>
                : <div className="w-14 h-14 border border-[#E5E7EB] flex flex-col items-center justify-center text-[#6B7280]"><FileText size={16}/><span className="text-[8px] mt-0.5 px-0.5 truncate max-w-[52px]">{a.filename}</span></div>}
              <button data-testid={`msg-remove-${a.id}`} onClick={()=>setAttachments(p=>p.filter(x=>x.id!==a.id))} className="absolute -top-2 -right-2 bg-[#12263A] text-white rounded-full p-0.5"><X size={12}/></button>
            </div>
          ))}
        </div>
      )}
      <textarea data-testid="msg-input" rows={3} value={newMsg} onChange={e=>setNewMsg(e.target.value)} placeholder="Write to your project lead…" className="w-full border border-[#E5E7EB] bg-white px-3 py-2"/>
      <div className="flex items-center gap-2 mt-2">
        <label data-testid="msg-attach" className="de-btn-secondary cursor-pointer">
          <Paperclip size={16}/> Attach
          <input type="file" multiple accept="image/*,.pdf,.heic,.heif" className="hidden" onChange={e=>{ addAttachments(Array.from(e.target.files||[])); e.target.value=""; }}/>
        </label>
        {uploadingCount>0 && <span className="text-xs text-[#6B7280] inline-flex items-center gap-1" data-testid="msg-upload-progress"><Loader2 size={14} className="animate-spin"/> Uploading {uploadProgress}%</span>}
        <button data-testid="msg-send" onClick={send} disabled={uploadingCount>0} className="de-btn-primary ml-auto disabled:opacity-50">Send</button>
      </div>
    </div>
  );
}
